/* eslint-disable max-len */
import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles<{ isDetailsView: boolean }>()((theme, {
    isDetailsView,
}) => {
    return {
        dataGridContainer: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: theme.palette.common.white,
            borderRadius: 4,
            '& .MuiDataGrid-root': {
                borderTopRightRadius: isDetailsView ? 0 : 4,
                borderBottomRightRadius: isDetailsView ? 0 : 4,

            },
            '& .MuiDataGrid-columnHeaders': {
                height: '36px',
            },
            '& .Mui-selected': {
                backgroundColor: `${theme.palette.primary[30]} !important`,
            },
            '& .MuiDataGrid-row': {
                minHeight: '36px !important',
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: `${theme.palette.primary[50]} !important`,
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: '14px !important',
                fontWeight: '500 !important',
                color: `${theme.palette.secondary[700]} !important`,
            },
            '& .MuiDataGrid-main': {
                background: theme.palette.secondary[50],
            },
            '& .MuiDataGrid-virtualScroller': {
                margin: `${theme.spacing(2)} ${theme.spacing(1)}`,
                background: theme.palette.common.white,
                borderRadius: theme.spacing(0.5),
            },
            '& .MuiDataGrid-cell:focus': {
                outline: 'none !important',
            },
        },
        bottomContainer: {
            position: 'sticky',
            bottom: 0,
            background: theme.palette.common.white,
            borderTop: `1px solid ${theme.palette.secondary[200]}`,
        },
        withPagination: {
            height: `calc(100vh - ${theme.spacing(16)})`,
        },
        archiveIconWrapper: {
            margin: '0 !important',
            padding: '0 !important',
        },
        archiveLink: {
            padding: '0 !important',
        },

        filterPanel: {
            width: '560px',
            minHeight: '120px',
            maxHeight: '560px',
            '&& .MuiDataGrid-panelContent': {
                overflowY: 'auto',
                maxHeight: 'unset',
            },
            '&& .MuiInputLabel-root': {
                left: '-14px !important',
                color: theme.palette.secondary[700],
            },
            '&& .MuiDataGrid-filterForm': {
                alignItems: 'flex-end',
            },
        },
        filterPanelColumnInput: {
            marginTop: '6px !important',
            '&& .Mui-disabled': {
                webkitTextFillColor: `${theme.palette.text.primary} !important`,
            },
            '&.Mui-disabled:before': {
                border: 'none !important',
            },
            '&& .MuiSelect-icon.Mui-disabled': {
                display: 'none !important',
            },
        },
        filterPanelHiddenElement: {
            display: 'none !important',
        },
        filterPanelDeleteIcon: {
            '&& .Mui-disabled': {
                visibility: 'hidden',
            },
        },
    }
})

export default useStyles
